import * as React from "react";
import { useDropzone } from "react-dropzone";
import Box from "@mui/material/Box";
import { Card } from "@mui/material";
import { useTranslation } from "react-i18next";

export const Dropzone = ({ sx, onAccepted }) => {
  const { t } = useTranslation(["project", "common"]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "image/jpeg": [],
      "image/png": [],
      "image/tiff": [],
    },
    onDropAccepted: (acceptedFiles) => {
      onAccepted?.(acceptedFiles);
    },
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        minHeight: "120px",
        ...sx,
      }}
    >
      <Card
        elevation={0}
        {...getRootProps({ className: "dropzone" })}
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          outline: "none",
          cursor: "pointer",
          color: (t) => "#ffffff",
          ...(isDragActive && {
            backgroundColor: (t) => t.palette.action.disabled,
            borderRadius: 0,
          }),
          ...(!isDragActive && {
            borderWidth: "1px",
            borderColor: (t) => "#ffffff",
            borderRadius: 0,
            borderStyle: "dashed",
          }),
        }}
      >
        <input {...getInputProps()} />
        {isDragActive && (
          <Box sx={{ color: "#000", fontWeight: 700 }}>
            {t("dropzoneDragActive")}
          </Box>
        )}
        {!isDragActive && (
          <>
            <Box
              sx={{
                textAlign: "center",
                fontWeight: 700,
                fontSize: "12px",
              }}
            >
              {t("dropzone")}
            </Box>
          </>
        )}
      </Card>
    </Box>
  );
};
